import { render, staticRenderFns } from "./ylfwPackage_list.vue?vue&type=template&id=ab24912c&scoped=true&"
import script from "./ylfwPackage_list.vue?vue&type=script&lang=js&"
export * from "./ylfwPackage_list.vue?vue&type=script&lang=js&"
import style0 from "./ylfwPackage_list.vue?vue&type=style&index=0&id=ab24912c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab24912c",
  null
  
)

export default component.exports